<template>
  <div class="body">
      <Headtow></Headtow>
      <div  id="bj">
        <div id="w-center">
          <div id="Breadcrumb">
            <i class="el-icon-house Breadcrumb-i" ></i>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>会员中心</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!-- 左侧 -->
          <Memberleft></Memberleft>

          <!-- 左侧结束 -->
          <div class="w-products rihgt">
            <div class="Member-right">
                <p class="content-jj">我的论坛</p>
            </div>
            <div class="h-20"></div>
            <div class="w-products rihgt Member-right">
              <div class="member-label">
                <el-tabs  v-model="activeName" @tab-click="handleClick"  v-loading="loading">
                  <el-tab-pane :label="'我的回答（'+info.hdcount+'）'" name="a">
                    <li class="forum-li"  v-for="(item, index) in list" :key="item.id" >
                      <!-- <router-link  :to="{ path: '/JobsCont',query: {id: item.fabuid}}"> -->
                      <div @click="tiao(item.fabuid,item.id)" class="cursor">
                        <div class="Forum-wen"><img src="../../static/img/luntan_wen.png"  alt="">{{item.title}} <span v-if="item.zt <2" class="yuandian"></span> </div>
                        <div class="Forum-wen"><img src="../../static/img/luntan_da.png" alt="">{{item.content}}</div>
                      </div>
                      <!-- </router-link> -->
                    </li>

                  </el-tab-pane>
                  <el-tab-pane :label="'我的提问（'+info.twcount+'）'" name="b">
                     <li class="forum-li"  v-for="(item, indexa) in list" :key="item.id">
                         <router-link  :to="{ path: '/JobsCont',query: {id: item.id}}">
                          <div class="Forum-wen"><img src="../../static/img/luntan_wen.png" alt="">{{item.title}}</div>
                         </router-link>
                     </li>
                  </el-tab-pane>
                  <el-tab-pane :label="'我的收藏（'+info.sccount+'）'" name="c">
                    <li class="forum-li"  v-for="(item, indexb) in list" :key="item.id">
                      <router-link  :to="{ path: '/JobsCont',query: {id: item.jobsid}}">
                        <div class="Forum-wen sc"><i class="el-icon-star-on" ></i>{{item.title}}</div>
                      </router-link>
                    </li>
                  </el-tab-pane>
                  <el-tab-pane :label="'收到点赞（'+info.dzcount+'）'" name="d">
                    <li class="forum-li"  v-for="(item, indexc) in list" :key="item.id">
                      <router-link  :to="{ path: '/JobsCont',query: {id: item.ltid}}">
                        <div class="Forum-wen sc ov1"><img src="../../static/img/zan2.png" style="width: 7%;" alt="">{{item.title}}</div>
                      </router-link>
                    </li>
                  </el-tab-pane>
                </el-tabs>
                <div class="page">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :page-size="12"
                    @current-change="handleCurrentChange"
                    :total="total">
                  </el-pagination>
                </div>
              </div>
              <div class="h-30"></div>
              <div class="h-30 clear"></div>
              <div class="h-30"></div>
            </div>

          </div>

          <div class="clear"></div>


        </div>
      </div>
       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import memberleft from '@/components/public/memberleft.vue'
export default{
  data(){
    return {
      loading:true,
      list:{},
      page:1,
      total:0,
      activeName:'a',
      info:{},
    }

  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Memberleft': memberleft,

  },
  mounted () {
    this.recordapi();
  },
  methods:{
    tiao(id,ztid){
      console.log(id,ztid)
      var that = this;
      that.$api.post("/Member/Forumzt",{'id':ztid}).then(res => {
        console.log(res);
        this.$router.push('/JobsCont?id='+id);
      });
    },
    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Member/Forum",{'userid':userid,'act':that.activeName,'page':this.page}).then(res => {
          console.log(res);
          that.list= res.list.data;
          that.loading = false
          this.total = res.list.total
          this.info = res.info
        });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },
    handleClick(tab) {
      if(tab.name == "d"){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Member/Forumdzxg",{'userid':userid}).then(res => {
          console.log(res);
        });
      }
      this.loading = true,
      this.list=[],
      this.activeName = tab.name;
      this.page = 1;
      this.recordapi();
    }
  }

 }
</script>



// WEBPACK FOOTER //
// src/components/Forum.vue